'use strict';

angular.module('app')
    .controller('OperatorCtrl', function($scope, $rootScope, $routeParams, $timeout, $location, leafletData, leafletBoundsHelpers, HomePage, DiveOperator, Search, item, operatorType, utils, localStorageService, gettextCatalog, config, seoName, GTM, cartService, ShopModel, Destinations, diviacLocalStorage, info) {

        var map;

        var vm = this;

        vm.utils = utils;
        vm.pageURL = $location.path();
        vm.showDS = false;
        vm.shopSlug = $routeParams.slug;

        vm.api = DiveOperator;
        vm.submitReview = DiveOperator.submitReview;
        vm.triggerWishlist = DiveOperator.triggerWishlist;
        vm.triggerWishlistOperators = DiveOperator.triggerWishlistOperators;

        $scope.layers = {};

        function init() {
            var shop = new ShopModel.shop(item, seoName);

            shop.recentlyViewed().generateSeoTags().setMainGTM();

            vm.info = shop._model;

            GTM.variables({
                operator_slug: $routeParams.slug,
                operator_country_slug: vm.info.countrySlug,
                country_name: vm.info.country,
                country_id: vm.info.countryId,
                area_name: vm.info.area,
                area_id: vm.info.areaId
            });


            // rooms count
            vm.roomsCount = config.roomsCount;
            vm.numberOfCourses = config.numberOfCourses;
            vm.guests = config.guests;
            vm.allReviews = [];
            vm.liveaboardFilter = {};

            vm.products = [];
            vm.cabins = [];

            vm.startCheckout = startCheckout;

            // init value to cart
            vm.carts = [];
            vm.cartTotalPrice = cartService.getTotalPrice;
            vm.dueNow = cartService.getDueNowValue();
            vm.selectedGuests = localStorageService.get('guests') || vm.guests[0];
            vm.shopType = shop._shopType;
            vm.checkout = cartService.checkout;
            vm.generateRoomPrice = shop.generateRoomPrice;
            vm.getOccupancyIcon = shop.getOccupancyIcon;

            vm.filterRoomPrice = shop.filterRoomPrice;

            vm.priceType = Search.priceType;

            //set available dates
            vm.getProducts = shop.getProducts;
            vm.addToCart = shop.addProductToCart;
            vm.questionForm = {
                shopSlug: vm.info.slug
            };
            // if (vm.shopType !== 'liveaboard') {
            //     vm.showDS = fal;
            // }

            if (vm.shopType === 'diveResort') {
                DiveOperator.getSeasons().then(function(data) {
                    vm.seasons = data;
                });
            }

            angular.extend(vm, shop.setDate());
            angular.extend($scope, shop.mapConfig());

            vm.cancellation = diviacLocalStorage.get('cancellation');

            DiveOperator.getVideos().then(function(data) {
                vm.videos = data;
            });

            shop.getPhotos().then(function(data) {
                angular.extend(vm, data);

                _.each(data.slidersImages, function(val, key) {
                    if (val.length > 0) {
                        $scope.activeSlider = key;
                        $scope.slidersImagesActive = val;

                        return false;
                    }
                });
            });


            leafletData.getMap('search-map').then(function(m) {
                map = m;
            });

            /*

             Get top 5 dive sites. Only for dive center page

             */

            if (vm.shopType === 'diveCenter') {
                DiveOperator.topDiveSites().then(function(data) {
                    vm.top5 = data;
                });
            }


            if (vm.info.productsCount > 0) {
                vm.haveProducts = true;
                $scope.haveProducts = true;
            }


            HomePage.getDestinations().then(function(data) {
                $scope.destinations = data;
            });

            /*
             Get reviews. For paginations we created array vm.allReviews and we will push data in this array
             if user click on "Show more" button.
             */


            DiveOperator.reviews(operatorType).then(function(rating) {
                vm.reviews = rating;

                GTM.variables({
                    operator_reviews_number: rating.numberOfReviews,
                    operator_rating_number: rating.numberOfReviews
                });

                _.map(rating.data.results, function(val) {
                    vm.allReviews.push(val);
                });

                vm.checkButtonInit();
            });

            triggerPins();

            DiveOperator.getHighlights($scope).then(function(res) {
                vm.highlights = res.data;

                $scope.highlightsMarkers = res.pins;
            });

            Destinations.getInfo(vm.info.kindVerbose === 'Liveaboard' ? vm.info.countrySlug : vm.info.areaSlug).then(function(val) {
                vm.country = val;
            });

            Destinations.getMarineLife(vm.info.kindVerbose === 'Liveaboard' ? 'country' : 'area').then(function(data) {
                $scope.marineLife = data;
                vm.marineLife = data;
                $scope.monthes = config.months;
            });
        }

        if (item.status === 404) {
            $rootScope.notFound = true;
        } else {
            init();
        }

        // GET PRODUCT ONLY IF WE HAVE IT ON CURRENT DIVE OPERATOR
        if (vm.info && vm.info.productsCount) {
            vm.getProducts(vm.sidebarFilterDate);
        }

        // get product for selected date on change month
        $scope.$watch(function() {
            return vm.filterDate;
        }, function(newVal, oldVal) {
            if (!oldVal) {
                oldVal = {};
            }
            if (newVal && ((newVal.startDate != oldVal.startDate || newVal.endDate != oldVal.endDate || newVal.month === 'Show all' && oldVal && oldVal.month !== 'Show all' || newVal.month === 'Show available')) && vm.info.productsCount) {

                vm.showPrevDateArrow = true;
                vm.showNextDateArrow = true;

                // hide prev/next month arrow
                _.each(vm.dates, function(val, index) {
                    // hide next arrow
                    if (val.startDate === newVal.startDate &&
                        val.endDate === newVal.endDate &&
                        vm.dates[index + 1] === undefined) {
                        vm.showNextDateArrow = false;
                    }
                    // hide prev arrow
                    if (val.startDate === newVal.startDate &&
                        val.endDate === newVal.endDate &&
                        vm.dates[index - 1] !== undefined &&
                        vm.dates[index - 1].startDate === undefined) {
                        vm.showPrevDateArrow = false;
                    }
                    // hide prev arrow if "show all" or "show available"
                    if (newVal.startDate === undefined) {
                        vm.showPrevDateArrow = false;
                        vm.showNextDateArrow = false;
                    }
                });
                vm.getProducts(newVal, true, vm.liveaboardFilter);
            }
        });

        /*
         Add review modal window step. Need to use $scope, because we can't work with vm in directive.
         */
        $scope.step = 1;

        vm.addReview = {};


        vm.askQuestion = function(form) {
            form.$submitted = true;

            if (form.$valid) {
                vm.questionForm.shopSlug = $routeParams.slug;
                if ($rootScope.user) {
                    DiveOperator.askQuestion(vm.questionForm);
                    $rootScope.showNotify(gettextCatalog.getString('Success'));
                    jQuery.fancybox.close();
                } else {
                    $rootScope.question = vm.questionForm;

                    $location.path('/login/');
                    jQuery.fancybox.close();
                }
            }
        };



        vm.getMoreReviews = function() {
            vm.reviewsLoading = true;
            DiveOperator.reviews(operatorType, vm.reviews.data.next).then(function(rating) {
                vm.reviews = rating;

                _.map(rating.data.results, function(val) {
                    vm.allReviews.push(val);
                });
                vm.reviews.data.results = vm.allReviews;

                vm.reviewsLoading = false;
            });
        };

        // save date to session storage
        $scope.saveDate = function(date) {
            if (date[0] && date[1]) {

                $timeout(function() {
                    // vm.from = date[0];
                    // vm.to = date[1];
                    vm.from = moment(date[0]).format('YYYY-MM-DD');
                    vm.to = moment(date[1]).format('YYYY-MM-DD');

                    vm.fromFullDate = date[0];
                    vm.toFullDate = date[1];

                    diviacLocalStorage.set('date', date);
                    vm.sidebarFilterDate = {
                        month: moment(date[0]).format("MMMM"),
                        from: moment(date[0]).format('YYYY-MM-DD'),
                        to: moment(date[1]).format('YYYY-MM-DD'),
                        year: (new Date(date[0])).getFullYear()
                    };

                    vm.haveDate = vm.sidebarFilterDate.from;
                    vm.filterDate = vm.sidebarFilterDate;
                    vm.getProducts(vm.filterDate, true);
                });

            } else {
                diviacLocalStorage.remove('date');
                localStorageService.remove('departure_date');
            }
        };

        // sidebar filter
        vm.showPrices = function() {
            if (vm.from && vm.to) {
                vm.sidebarFilterDate = vm.filterDate = {
                    month: moment(vm.from).format("MMMM"),
                    startDate: moment(vm.from).format('YYYY-MM-DD'),
                    endDate: moment(vm.to).format('YYYY-MM-DD'),
                    year: (new Date(vm.from)).getFullYear()
                };
                vm.fromFullDate = moment(vm.from).utc().toDate();
                vm.toFullDate = moment(vm.to).utc().toDate();
                //vm.getProducts(vm.filterDate, true);
                vm.showDetail = false;


                diviacLocalStorage.set('date', [vm.from, vm.to]);

                if (vm.selectedGuests) {
                    localStorageService.set('guests', vm.selectedGuests);
                }

            } else if (!vm.from && !vm.to) {
                diviacLocalStorage.remove('date');
                diviacLocalStorage.remove('departure_date');
                if (vm.selectedGuests) {
                    vm.sidebarFilterDate = vm.filterDate = {
                        month: 'Show all'
                    };
                    vm.fromFullDate = null;
                    vm.toFullDate = null;

                    localStorageService.set('guests', vm.selectedGuests);
                }
            }

            $rootScope.scrollTo('#pricing');
        };


        vm.showOnMap = function() {
            vm.showDS = !vm.showDS;


            if (vm.showDS) {
                map.fitBounds($scope.markers);

                GTM.event('map_show_dive_sites');
            } else {
                GTM.event('map_hide_dive_sites');
            }
        };


        $scope.$watch(function() {
            return vm.showDS;
        }, function() {
            if (vm.showDS) {
                triggerPins();
            }
        });


        $scope.resize = function() {
            leafletData.getMap('search-map').then(function(m) {
                m.invalidateSize();

                $timeout(function() {
                    if ($scope.markers && $scope.markers.length > 1) {
                        m.fitBounds($scope.markers);
                    } else if ($scope.markers.length) {
                        $scope.center = {
                            lat: $scope.markers[0].lat,
                            lng: $scope.markers[0].lng,
                            zoom: 10
                        };
                    }
                }, 500);
            });
        };

        vm.plus = function(type) {
            if (!vm.enquire[type]) {
                vm.enquire[type] = 0;
            }
            vm.enquire[type] += 1;
        };
        vm.minus = function(type) {
            if (!vm.enquire[type]) {
                vm.enquire[type] = 0;
            }
            if (vm.enquire[type] <= 0) {
                return vm.enquire[type] = 0;
            }
            vm.enquire[type] -= 1;
        };

        vm.sendEnquiry = function(valid) {
            if (valid) {
                vm.enquire.shop = vm.info.id;
                vm.enquire.referrer = window.location.href;

                GTM.variables({
                    user_refer_affiliate_id: vm.enquire.affiliateId
                });

                DiveOperator.bookingEnquire(vm.enquire).then(function() {
                    vm.enquire = {
                        finished: true
                    };

                    GTM.event('user_bookig_enquiry_complete');
                    jQuery.fancybox.update();

                    $timeout(function() {
                        jQuery.fancybox.close();
                        jQuery.fancybox.update();

                        $timeout(function() {
                            vm.enquire.finished = false;
                        }, 1000);
                    }, 3000);
                });
            }
        };

        $scope.plus = function(type) {
            if (!$scope[type]) {
                $scope[type] = 0;
            }
            $scope[type] += 1;
        };


        $scope.minus = function(type) {
            if (!$scope[type]) {
                $scope[type] = 0;
            }
            if ($scope[type] <= 0) {
                return $scope[type] = 0;
            }
            $scope[type] -= 1;
        };


        $scope.$on('leafletDirectiveMarker.search-map.click', function(e, args) {
            $scope._infowindow = args.model.info;
        });

        $scope.$on('leafletDirectiveMarker.map-highlight.click', function(e, args) {
            $scope._infowindow = args.model.info;
        });

        $rootScope.popupUrl = function() {
            $location.search('showRatingPopup', 'show');
        };

        $scope.clearReviewForm = function() {
            vm.addReview = {};
            $rootScope.returnPrevURL();
        };


        DiveOperator.getOtherDiveoperators().then(function(operators) {
            vm.otherDiveOperatorsList = operators;

            var ecommerce = {
                currencyCode: "USD",
                impressions: []
            };

            _.each(operators, function(val, key) {
                ecommerce.impressions.push({
                    name: val.title,
                    id: val.id,
                    price: val.priceMin,
                    list: "Other",
                    position: key + 1
                });
            });

            GTM.products(null, ecommerce);
        });

        vm.responsive = config.slickResponsive;

        vm.generateUrl = function(result) {
            return Search.generateUrl(result);
        };

        vm.checkButtonInit = function() {
            if ($location.search().showRatingPopup && $location.search().showRatingPopup === 'show') {
                $timeout(function() {
                    $('#review-btn').click();

                    GTM.event('reviews_write_new_start');
                }, 150);
            } else {
                $location.search('showRatingPopup', null);
            }
        };

        vm.initDiveResortReviews = function() {
            if (!vm.info) {
                return true;
            }
            if (vm.reviews && !vm.reviews.averageVotes.rate || !vm.info.isActiveReviewTab && !vm.info.tripAdvisor && !vm.info.resortTripAdvisor) {
                vm.isActiveReviewTab = "diviacReview";
            } else if (vm.info.resortTripAdvisor) {
                vm.isActiveReviewTab = "tripAdvisorResortReview";
                vm.selectedTAData = vm.info.resortTripAdvisor.data.reviews;
            } else if (vm.info.tripAdvisor) {
                vm.isActiveReviewTab = "tripAdvisorReview";
                vm.selectedTAData = vm.info.tripAdvisor.data.reviews;
            } else if (vm.info.scubaTribe) {
                vm.isActiveReviewTab = "scubaTribe";
            }
        };

        vm.addProduct = function(variant, product, type, packages) {
            if (type) {
                if (type === "plus") {
                    variant.qty = variant.qty >= 99 ? 99 : variant.qty + 1;
                } else {
                    if (variant.qty <= 0) {
                        variant.qty = 0;
                    } else {
                        variant.qty -= 1;
                    }
                }
            }

            if (!variant.qty) {
                variant.qty = 0;
            }


            variant = _.clone(variant);
            product = _.clone(product);

            product.url = $location.path();
            variant.shopKindVerbose = vm.info.kindVerbose;

            var gtmType;

            if (packages) {
                packages = _.clone(packages);
                product.title = packages.title + ' / ' + product.roomCategory.title;
                product.currency = variant.currency;
                product.kind = 100;
                product.duration = packages.duration;
                variant.dateTo = null;
                product.images = packages.images;
                gtmType = 'checkout_dr_package_cart_';
            }

            if (variant.sourceKind === "RoomCategory") {
                variant.dateFrom = moment(vm.fromFullDate).format('YYYY-MM-DD');
                variant.dateTo = moment(vm.toFullDate).format('YYYY-MM-DD');
                product.dateFrom = variant.fromFullDate;
                product.dateTo = variant.toFullDate;
                variant.pricePerDay = variant.priceNet;
                variant.numberOfDays = utils.dayDiff(vm.from, vm.to);
                variant.pricePerOneProduct = variant.priceNet;

                gtmType = 'checkout_dr_room_cart_';
            } else {
                variant.pricePerOneProduct = variant.priceNet;
                variant.dateFrom = vm.fromFullDate;
                variant.dateTo = null;
                product.dateFrom = variant.fromFullDate;
            }

            if (variant.sourceKind === 'DiveProduct') {
                variant.title = product.title;
                variant.currency = product.currency;
            }


            product.sourceKind = variant.sourceKind;
            variant.priceNet = variant.pricePerOneProduct * variant.qty;


            product.selectedProduct = variant;
            delete product.prices;

            var cart = _.clone(vm.carts);

            if (cart.length) {
                // group item in the cart
                var addToCart = true;

                _.each(cart, function(el) {
                    if (el.selectedProduct.dateFrom == product.selectedProduct.dateFrom &&
                        el.selectedProduct.dateTo == product.selectedProduct.dateTo &&
                        el.selectedProduct.id == product.selectedProduct.id ||
                        (variant.sourceKind === 'DiveProduct' && el.selectedProduct.id == product.selectedProduct.id)) {

                        el.selectedProduct.qty = +variant.qty;
                        el.selectedProduct.priceNet = el.selectedProduct.pricePerOneProduct * el.selectedProduct.qty;

                        addToCart = false;
                    }
                });

                if (type && type !== "plus") {
                    GTM.products(gtmType + 'remove', {
                        'remove': {
                            'products': [{
                                title: product.title,
                                id: product.id,
                                price: product.selectedProduct.pricePerOneProduct,
                                brand: item.title,
                                category: product.selectedProduct.shopKindVerbose,
                                quantity: 1
                            }]
                        }
                    });
                }

                if (variant.qty === 0) {
                    cart = _.reject(cart, function(val) {
                        return val.selectedProduct.id === variant.id;
                    });
                }

                // if item grouped we haven't add product to cart
                if (addToCart && variant.qty) {
                    delete product.uniqueProducts;
                    delete product.variants;
                    delete product.selectedProduct.occupancy;
                    delete product.selectedProduct.packageType;
                    delete product.occupancy;
                    delete product.packageType;

                    GTM.products(gtmType + 'add', {
                        currencyCode: 'USD',
                        add: {
                            products: [{
                                title: product.title,
                                id: product.id,
                                price: product.selectedProduct.pricePerOneProduct,
                                brand: item.title,
                                category: product.selectedProduct.shopKindVerbose,
                                quantity: product.selectedProduct.qty
                            }]
                        }
                    });

                    cart.push(product);
                }

                vm.carts = cart;

            } else {
                vm.carts = [product];
            }
        };

        vm.setVariantQty = function(variant) {
            if (!window.localStorage['productInCart']) {
                variant.qty = 0;
            } else {
                var cart = JSON.parse(window.localStorage['productInCart']);

                var element = _.find(cart, function(val) {
                    return val.selectedProduct.id === variant.id;
                });

                variant.qty = element ? element.selectedProduct.qty : 0;
            }
        };


        function setCancellation(data) {
            if (data.dueNow.length === 0) {
                return true;
            }

            var cancellation = data.dueNow[0];

            vm.cancellation = {
                policy: cancellation.cancellationPolicy,
                milestones: cancellation.cancellationMilestones,
                policyText: _.find(info.shop.CANCELLATION_POLICY, function(val) {
                    return val[0] === cancellation.cancellationPolicy;
                }),
                paymentTerms: cancellation.paymentTerms,
                paymentMilestones: _.reject(cancellation.milestones, {
                    isDueNow: true
                }),
                qty: data.dueNow.length
            };

            diviacLocalStorage.set('cancellation', vm.cancellation);
        }


        function startCheckout(product, kind, gtmEvent) {
            if (!vm.haveProducts) {
                return true;
            }

            var url = '/checkout',
                eventKind;

            if (vm.shopType === 'diveResort') {
                eventKind = 'dr_';
                url += '/dive-resort/';
            } else if (vm.shopType === 'diveCenter') {
                eventKind = 'dc_';
                url += '/dive-center/';
            }

            if (gtmEvent) {
                GTM.event('checkout_' + eventKind + gtmEvent);
            }

            url += $routeParams.location + '/' + $routeParams.slug + '/';

            if (!product && !kind) {
                $location.path(url).hash('');

                return true;
            } else if (kind) {
                $rootScope.carts = _.filter(vm.carts, {
                    sourceKind: kind
                });
                $location.path(url).hash('');

                return true;
            }

            $location.path(url).search({
                productId: product.id
            }).hash('');

        }

        vm.checkProducts = function(type) {
            if (type === 'rooms') {
                return _.find(vm.carts, {
                    sourceKind: "RoomCategory"
                });
            } else {
                return _.find(vm.carts, {
                    kind: 100
                });
            }
        };

        function triggerPins() {
            DiveOperator.getResorts($scope, vm.info).then(function(data) {
                if (data.shopPin && data.shopPin.length && operatorType != utils.shopKind('Liveaboard')) {
                    $scope.markers = data.shopPin;
                    $scope._infowindow = data.shopPin[0].info;
                }

                if (data.pins && vm.showDS) {
                    $scope.markers = _.clone($scope.markers.concat(data.pins));

                    if ($scope.highlightsMarkers) {
                        $scope.markers = _.clone($scope.markers.concat($scope.highlightsMarkers));
                    }
                }

                if ($scope.markers && $scope.markers.length > 1 && map) {
                    $timeout(function() {
                        if ($scope.markers.length) {
                            map.fitBounds($scope.markers);
                        }
                    }, 350);
                } else if ($scope.markers && $scope.markers.length === 1 && map) {
                    map.fitBounds($scope.markers);
                    $timeout(function() {
                        $scope.center.zoom = 10;
                    }, 150);
                }
            });
        }

        return vm;

    });
